module.exports = __webpack_public_path__ + "img/icono.8663f4a6.png";